import { api } from '@/lib/api/client'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'

export interface ArticleCategory {
  id: string
  slug: string
  name: string
  image: string
  order: number
  createdAt: string
  updatedAt: string
}

export interface CreateArticleCategoryInput {
  slug: string
  name: string
  image?: string
  order?: number
}

export const articleCategoriesApi = {
  list:   () => api.get<ArticleCategory[]>('/article-categories'),
  create: (p: CreateArticleCategoryInput) => api.post<ArticleCategory>('/admin/article-categories', p),
  update: (id: string, p: Partial<CreateArticleCategoryInput>) => api.patch<ArticleCategory>(`/admin/article-categories/${id}`, p),
  remove: (id: string) => api.delete<{ ok: boolean }>(`/admin/article-categories/${id}`),
}

const KEY = ['article-categories'] as const

export function useArticleCategories() {
  return useQuery({ queryKey: KEY, queryFn: () => articleCategoriesApi.list(), staleTime: 60_000 })
}
export function useCreateArticleCategory() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (p: CreateArticleCategoryInput) => articleCategoriesApi.create(p), onSuccess: () => qc.invalidateQueries({ queryKey: KEY }) })
}
export function useUpdateArticleCategory() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (v: { id: string; input: Partial<CreateArticleCategoryInput> }) => articleCategoriesApi.update(v.id, v.input), onSuccess: () => qc.invalidateQueries({ queryKey: KEY }) })
}
export function useDeleteArticleCategory() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (id: string) => articleCategoriesApi.remove(id), onSuccess: () => qc.invalidateQueries({ queryKey: KEY }) })
}
